import emptyFolder from '../images/empty2.png'

export default function EmptyFolder({texto}) {
    return (
        <div style={{ marginTop: "120px", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <img src={emptyFolder} alt='Imagem de uma pasta vazia' width={300} style={{ marginBottom: '20px', borderRadius: '20px', boxShadow: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)" }} />
            <h2 className='h2-sem-demandas'>Selecione o {texto} no filtro</h2>
            <h3 className='h3-sem-demandas'>As informações serão exibidas após selecionar e aplicar o filtro.</h3>
        </div>
    )
}